import { MessageCircle } from "lucide-react";
import { useLang } from "../i18n";
import { WA_LINK } from "../data/site";

export default function FloatingWhatsApp() {
  const { t } = useLang();
  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="WhatsApp"
      className="wa-pulse fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#63E51D] px-5 py-3.5 font-bold text-black shadow-[0_8px_30px_rgba(99,229,29,0.35)] transition-transform duration-300 hover:scale-105"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden text-sm sm:inline">{t("floating.quote")}</span>
    </a>
  );
}
